import { render } from "./AnswerButton.vue?vue&type=template&id=598567e3&ts=true"
import script from "./AnswerButton.vue?vue&type=script&lang=ts"
export * from "./AnswerButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__